// https://vuex.vuejs.org/en/getters.html

export default {
  getFilteredAccounts: (state) => {
    let accounts = []
    switch (state.accountAgreementFilter) {
      case 'all':
        return state.masterAccounts
        break
      case 'sp':
        // special filtering
        break
      case 'spp':
      case 'ppa':
        return state.masterAccounts.filter(account => account.agreement === this.selectedFilter)
        break
      case 'other':
        break
      default:
        break
    }
    return accounts
  },
  getAccountHeaders: state => {
    let headers = []
    let headersToShow = ['Actions', 'OppReg_Id', 'ACE_Opportunity_Number', 'AWS_EUR_Date', 'AWS_ACE_Launch_Date', 'Acct_name', 'Acct_Status', 'Acct_Alias_Group', 'Acct_Offering_Stat', 'Acct_DL', 'Acct_ID', 'Date_onboarded', 'Last_Date_Validated', 'Date_Suspended', 'MP_ID', 'DateMarkedAsUnknown', 'Previous_MP_ID', 'Customer_Name', 'Customer_Alias_Group', 'Managed_Svc', 'AWS_Support_Type', 'Customer_Region', 'Acct_Restricted', 'MFA', 'Root_Credential_Store', 'DXC_discount', 'Client_discount', 'MP_uplift', 'Client_uplift', 'WBS_code', 'IWO_Code', 'Comments', 'AWS_Usage_Type', 'AWS_Government_Customer', 'AWS_Advising_Government', 'GovCloud_Resource_Account']
    headersToShow.forEach(header => {
      let headerIndex = state.accountHeaders.findIndex(accHeader => accHeader.value === header)
      if (headerIndex !== -1) {
        headers.push(state.accountHeaders[headerIndex])
      }
    })

    console.log('HEADERS')
    console.log(headers)
    return headers
  },
  getAccountHeadersByMP: state => {
    let headers = []
    let headersToShow = ['Acct_name', 'OppReg_Id', 'Acct_Status', 'Acct_Offering_Stat', 'Acct_DL', 'Acct_ID', 'Date_onboarded', 'Last_Date_Validated', 'Date_Suspended', 'MP_ID', 'DateMarkedAsUnknown', 'Previous_MP_ID', 'Customer_Name', 'Customer_Alias_Group', 'Managed_Svc', 'AWS_Support_Type', 'Customer_Region', 'Acct_Restricted', 'MFA', 'Root_Credential_Store', 'DXC_discount', 'Client_discount', 'MP_uplift', 'Client_uplift', 'WBS_code', 'IWO_Code', 'Comments']
    headersToShow.forEach(header => {
      let headerIndex = state.accountHeaders.findIndex(accHeader => accHeader.value === header)
      if (headerIndex !== -1) {
        headers.push(state.accountHeaders[headerIndex])
      }
    })
    return headers
  }
}
